// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from '../store';
import * as api from '../api';
import { COLUMN_TYPE_INFO, type ColumnType } from '../types';

interface Props {
  boardId: string;
  onClose: () => void;
}

export default function AddColumnMenu({ boardId, onClose }: Props) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const handleAdd = async (type: ColumnType) => {
    const info = COLUMN_TYPE_INFO[type];
    const col = await api.createColumn(boardId, info.label, type);
    dispatch({
      type: 'ADD_COLUMN',
      column: { ...col, config: typeof col.config === 'string' ? col.config : JSON.stringify(col.config) },
    });
    onClose();
  };

  const allTypes = Object.entries(COLUMN_TYPE_INFO) as [ColumnType, typeof COLUMN_TYPE_INFO[ColumnType]][];
  const filtered = search
    ? allTypes.filter(([, info]) => info.label.toLowerCase().includes(search.toLowerCase()))
    : allTypes;

  const categories = ['Essentials', 'Super useful', 'More columns'];

  return (
    <div className="add-col-menu" ref={ref}>
      <input
        className="add-col-search"
        autoFocus
        placeholder="Search or describe your column"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {categories.map((cat) => {
        const items = filtered.filter(([, info]) => info.category === cat);
        if (items.length === 0) return null;
        return (
          <div key={cat}>
            <div className="add-col-category">{cat}</div>
            <div className="add-col-grid">
              {items.map(([type, info]) => (
                <button key={type} className="add-col-option" onClick={() => handleAdd(type)}>
                  <div className="add-col-icon" style={{ backgroundColor: info.color }}>
                    {info.icon}
                  </div>
                  {info.label}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
